"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _lodash = require("lodash");
var _BlogTags = _interopRequireDefault(require("../../components/Blog/BlogTags"));
var _BlogCard = _interopRequireDefault(require("../../components/Blog/BlogCard"));
var _reactBlueprintLibrary = require("react-blueprint-library");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 * A BlogList component
 *
 * @param {object} props Properties used for the component
 *
 * @returns {React.ReactElement} A BlogList
 */
function BlogCardList(props) {
  var _props$fields;
  var [filteredResults, setFilteredResults] = (0, _react.useState)([]);
  var [pageNum, setPageNum] = (0, _react.useState)(1);
  if (!((_props$fields = props.fields) !== null && _props$fields !== void 0 && _props$fields.blogs)) return null;
  var itemsPerPage = 18;
  var results = props.fields.blogs || [];
  var numberOfListings = results.length;
  var totalPages = Math.ceil(numberOfListings / itemsPerPage);
  var onChange = newPage => {
    var start = (newPage - 1) * itemsPerPage;
    setFilteredResults(results.slice(start, start + itemsPerPage));
    setPageNum(newPage);
    window.scrollTo(0, 0);
  };
  (0, _react.useEffect)(() => {
    var start = (pageNum - 1) * itemsPerPage;
    setFilteredResults(results.slice(start, start + itemsPerPage));
  }, [pageNum, results]);
  var TagList = (0, _lodash.map)(results, eachItem => {
    if (eachItem.topics.length > 0) {
      return (0, _lodash.map)(eachItem.topics, tag => tag);
    }
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-spacing bloglist"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "mm-spacing"
  }, (0, _lodash.map)(filteredResults, (eachItem, key) => /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    className: "align-self-stretch",
    lg: 4,
    sm: 12,
    key: key
  }, /*#__PURE__*/_react.default.createElement(_BlogCard.default, {
    item: eachItem,
    id: key,
    params: props.params
  })))), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Pagination, {
    currentPage: pageNum,
    itemsPerPage: itemsPerPage,
    numberOfItems: numberOfListings,
    onChange: onChange
  }), /*#__PURE__*/_react.default.createElement(_BlogTags.default, {
    tags: TagList.flat()
  }));
}
var _default = exports.default = BlogCardList;